import { render, staticRenderFns } from "./CartGroup.vue?vue&type=template&id=2d52726c&scoped=true&"
import script from "./CartGroup.vue?vue&type=script&lang=js&"
export * from "./CartGroup.vue?vue&type=script&lang=js&"
import style0 from "./CartGroup.vue?vue&type=style&index=0&id=2d52726c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52726c",
  null
  
)

export default component.exports